import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { usePermission } from './usePermission';
import useModalActions from '@hooks/common/useModalAction';

export function usePermissionMutation<TData = void, TVariables = void>(
  options: UseMutationOptions<TData, unknown, TVariables>
) {
  const isAdmin = usePermission();
  const { errorDefaultAction } = useModalActions();

  return useMutation<TData, unknown, TVariables>({
    ...options,
    mutationFn: async (variables) => {
      if (!isAdmin) {
        errorDefaultAction('You do not have permission to perform this action.');
        return undefined as unknown as TData; 
      }

      if (!options.mutationFn) {
        throw new Error('mutationFn is not defined.');
      }

      return options.mutationFn(variables);
    },
  });
}